// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.progress-module__wrapper___faMGU {
  height: 100%;
  position: relative;
  width: 100%;
}
.progress-module__wrapper--cover-children___NoIp6 {
  z-index: 1;
}

/* rtl:begin:ignore */
.progress-module__children___pqUSk {
  left: 50%;
  transform: translate(-50%, -50%);
}

/* rtl:end:ignore */
.progress-module__children___pqUSk {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.progress-module__children--cover-children___degkf {
  z-index: -1;
}

.progress-module__main-svg--full___T_01w {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/charts/progress/progress.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AAMF;AALE;EACE,UAAA;AAOJ;;AAHA,qBAAA;AACA;EACE,SAAA;EACA,gCAAA;AAMF;;AAJA,mBAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAMF;AALE;EACE,WAAA;AAOJ;;AAHA;EACE,WAAA;EACA,YAAA;AAMF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils';\n\n.wrapper {\n  height: 100%;\n  position: relative;\n  width: 100%;\n  &--cover-children {\n    z-index: 1;\n  }\n}\n\n/* rtl:begin:ignore */\n.children {\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n/* rtl:end:ignore */\n\n.children {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 50%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  &--cover-children {\n    z-index: -1;\n  }\n}\n\n.main-svg--full {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `progress-module__wrapper___faMGU`,
	"wrapper--cover-children": `progress-module__wrapper--cover-children___NoIp6`,
	"children": `progress-module__children___pqUSk`,
	"children--cover-children": `progress-module__children--cover-children___degkf`,
	"main-svg--full": `progress-module__main-svg--full___T_01w`
};
export default ___CSS_LOADER_EXPORT___;
